import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-agent',
  templateUrl: './sidebar-agent.component.html',
  styleUrls: ['./sidebar-agent.component.scss']
})
export class SidebarAgentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
